/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Thu Dec 14 2023
 **/

import axios from "axios";

type AuthData = {
	access_token: string;
	token_type: string;
	expires_in: number;
	scope: string;
	jti: string;
};

export default class RMBox {
	private addNameValue(data: string, name: string, value: string) {
		const result = name + "=" + value;
		if (data.endsWith("?")) {
			return data + result;
		} else {
			return data + "&" + result;
		}
	}

	private get generateUUID() {
		return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
	}

	private makeAuth() {
		return new Promise<string>((resolve, reject) => {
			const clientID = "client01";
			const secret = "secret01";
			const encodedAuthInfo = btoa(clientID + ":" + secret);
			axios
				.post<AuthData>(
					"https://devapi.remotemeeting.com/oauth/token",
					{ grant_type: "client_credentials", scope: "USER" },
					{
						headers: {
							Authorization: "Basic " + encodedAuthInfo,
							"Content-Type": "application/x-www-form-urlencoded"
						}
					}
				)
				.then((result) => {
					console.debug("#RMBox# auth", result.data.access_token);
					resolve(result.data.access_token);
				})
				.catch((error) => {
					console.warn("#RMBox# auth failed", error);
					reject(error);
				});
		});
	}

	public startConference() {
		this.makeAuth().then((access_token) => {
			let link = "https://dev.remotemeeting.com/openapi/conference/start?";
			link = this.addNameValue(link, "access_token", access_token);
			link = this.addNameValue(link, "displayName", "주최자");
			link = this.addNameValue(link, "clientUserId", "clientUser01");
			link = this.addNameValue(link, "clientCompanyId", "clientCompany01");
			link = this.addNameValue(link, "requestId", this.generateUUID);
			link = this.addNameValue(link, "startCallbackUrl", "");
			link = this.addNameValue(link, "endCallbackUrl", "");
			link = this.addNameValue(link, "recordCallbackUrl", "");
			link = this.addNameValue(link, "title", "RMBox");

			window.open(link, "_blank");
		});
	}
}
